import type { Property, PropertyPhotos } from "../../global/types";

type PropertyAddressShape = Property["address"];

const PHOTO_STAMP = "2020-01-01T00:00:00Z";

/** Stub entries only drive slide count in the style guide; media is rendered as wireframes. */
function buildSlideStubs(count: number): PropertyPhotos[] {
  return Array.from({ length: count }, (_, index) => ({
    id: 10_000 + index,
    created_at: PHOTO_STAMP,
    updated_at: PHOTO_STAMP,
    is_main: index === 0 ? 1 : 0,
    order: index + 1,
    url_l: "",
    url_m: "",
    url_s: "",
  }));
}

function buildAddress(
  partial: Pick<PropertyAddressShape, "address" | "neighborhood" | "city" | "uf"> &
    Partial<Omit<PropertyAddressShape, "address" | "neighborhood" | "city" | "uf">>
): PropertyAddressShape {
  return {
    rooms: null,
    number: 120,
    complement: "",
    latitude: "",
    longitude: "",
    ...partial,
  };
}

function createMockProperty(
  overrides: Pick<Property, "id" | "title" | "rent_value" | "rooms" | "bathrooms" | "garages" | "address" | "photos"> &
    Partial<Pick<Property, "area" | "suites" | "description">>
): Property {
  const area = overrides.area ?? 65;
  const suites = overrides.suites ?? 0;
  const description = overrides.description ?? "";

  return {
    id: overrides.id,
    consultant_id: 0,
    address_id: 0,
    address: overrides.address,
    photos: overrides.photos,
    title: overrides.title,
    description,
    allow_pets: 0,
    water_included: 0,
    gas_included: 0,
    area,
    rooms: overrides.rooms,
    bathrooms: overrides.bathrooms,
    suites,
    garages: overrides.garages,
    garbage_tax: "0",
    is_furnished: 0,
    rent_value: overrides.rent_value,
    condominium_value: "0",
    condominium_free: 0,
    iptu_value: "0",
    is_nearby_clinics: 0,
    is_nearby_major_roads: 0,
    is_nearby_schools: 0,
    is_nearby_mall: 0,
    is_nearby_public_transport: 0,
    is_rented: 0,
    has_ac: 0,
    has_backyard: 0,
    has_porch: 0,
    has_storage: 0,
    has_cable_tv: 0,
    has_bbq: 0,
    has_elevator: 0,
    has_garden: 0,
    has_gourmet: 0,
    has_gym: 0,
    has_party: 0,
    has_playground: 0,
    has_pool: 0,
    has_home_cinema: 0,
    has_tennis_court: 0,
    has_sports: 0,
    has_sauna: 0,
    has_spa: 0,
    has_sea_view: 0,
    has_gourmet_porch: 0,
    has_24h_concierge: 0,
    has_game_room: 0,
  };
}

export const STYLE_GUIDE_MOCK_PROPERTIES: Property[] = [
  createMockProperty({
    id: 900_001,
    title: "Tipo A, Bairro Norte, 1 quarto",
    rent_value: "1200.00",
    rooms: 1,
    bathrooms: 1,
    garages: 1,
    address: buildAddress({
      address: "Rua Exemplo Um",
      neighborhood: "Bairro Norte",
      city: "Cidade Exemplo",
      uf: "AA",
    }),
    photos: buildSlideStubs(3),
  }),
  createMockProperty({
    id: 900_002,
    title: "Tipo B, Bairro Leste, 3 quartos",
    rent_value: "2400.00",
    rooms: 3,
    bathrooms: 2,
    garages: 2,
    area: 120,
    address: buildAddress({
      address: "Avenida Modelo Dois",
      neighborhood: "Bairro Leste",
      city: "Cidade Exemplo",
      uf: "AA",
    }),
    photos: buildSlideStubs(2),
  }),
  createMockProperty({
    id: 900_003,
    title: "Tipo A, Bairro Sul, 2 quartos",
    rent_value: "2100.00",
    rooms: 2,
    bathrooms: 2,
    garages: 1,
    address: buildAddress({
      address: "Rua Modelo Três",
      neighborhood: "Bairro Sul",
      city: "Cidade Exemplo",
      uf: "AA",
    }),
    photos: buildSlideStubs(3),
  }),
  createMockProperty({
    id: 900_004,
    title: "Tipo C, Centro, 1 quarto",
    rent_value: "800.00",
    rooms: 1,
    bathrooms: 1,
    garages: 0,
    area: 32,
    address: buildAddress({
      address: "Rua Modelo Quatro",
      neighborhood: "Centro",
      city: "Cidade Exemplo",
      uf: "AA",
    }),
    photos: buildSlideStubs(1),
  }),
];
